import script from "./olmap2New.vue?vue&type=script&setup=true&lang=js"
export * from "./olmap2New.vue?vue&type=script&setup=true&lang=js"

import "./olmap2New.vue?vue&type=style&index=0&id=445eda22&scoped=true&lang=css"
import "./olmap2New.vue?vue&type=style&index=1&id=445eda22&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-445eda22"]])

export default __exports__